<script lang="ts" setup>
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue"
import { ElScrollbar } from "element-plus"
import { ref } from "vue"

const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>()
const scrollbarContentRef = ref<HTMLDivElement>()

/** 当前滚动条距离左边的距离 */
let currentScrollLeft = 0
/** 每次滚动距离 */
const translateDistance = 200

/** 滚动时触发 */
const scroll = ({ scrollLeft }: { scrollLeft: number }) => {
  currentScrollLeft = scrollLeft
}

/** 点击滚动 */
const scrollTo = (direction: "left" | "right") => {
  let scrollLeft = 0
  /** 可滚动内容的长度 */
  const scrollbarContentRefWidth = scrollbarContentRef.value!.clientWidth
  /** 滚动可视区宽度 */
  const scrollbarRefWidth = scrollbarRef.value!.wrapRef!.clientWidth
  /** 最后剩余可滚动的宽度 */
  const lastDistance = scrollbarContentRefWidth - scrollbarRefWidth - currentScrollLeft
  // 没有横向滚动条，直接结束
  if (scrollbarRefWidth > scrollbarContentRefWidth) return
  if (direction === "left") {
    scrollLeft = Math.max(0, currentScrollLeft - translateDistance)
  } else {
    scrollLeft = Math.min(currentScrollLeft + translateDistance, currentScrollLeft + lastDistance)
  }
  scrollbarRef.value!.setScrollLeft(scrollLeft)
}
</script>

<template>
  <div class="scroll-container">
    <el-icon class="left arrow" @click="scrollTo('left')">
      <ArrowLeft />
    </el-icon>
    <el-scrollbar ref="scrollbarRef" @scroll="scroll">
      <div ref="scrollbarContentRef" class="scrollbar-content">
        <slot />
      </div>
    </el-scrollbar>
    <el-icon class="arrow right" @click="scrollTo('right')">
      <ArrowRight />
    </el-icon>
  </div>
</template>

<style lang="scss" scoped>
.scroll-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  user-select: none;

  .arrow {
    width: 40px;
    height: 100%;
    cursor: pointer;

    &.left {
      box-shadow: 5px 0 5px -6px #ccc;
    }

    &.right {
      box-shadow: -5px 0 5px -6px #ccc;
    }
  }

  .el-scrollbar {
    flex: 1;
    // 横向超出窗口长度时，显示滚动条
    white-space: nowrap;

    .scrollbar-content {
      display: inline-block;
    }
  }

  .screenfull {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    cursor: pointer;
  }
}
</style>
